import React, { FC, ReactNode, createContext, useState } from "react"

import LocalStorageRepository from "@infra/repositories/LocalStorageRepository"

import { TransactionStatecontextBase } from "./default/TransactionContextBase"

type TransactionContextType = {
  contextBase: TransactionStatecontextBase
  setContextBase: React.Dispatch<
    React.SetStateAction<TransactionStatecontextBase>
  >
}

export const getBaseStorage = () => {
  const transactionBase = JSON.parse(
    LocalStorageRepository.get("transactionBase")
      ? (LocalStorageRepository.get("transactionBase") as string)
      : "{}"
  )
  const baseStorage: TransactionStatecontextBase =
    transactionBase as unknown as TransactionStatecontextBase
  return baseStorage
}

const ctxTransactionState = createContext<TransactionContextType>({
  contextBase: new TransactionStatecontextBase(),
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setContextBase: () => { }
})

const TransactionStateContext: FC<{ children: ReactNode }> = ({ children }) => {
  const [contextBase, setContextBase] = useState<TransactionStatecontextBase>(
    getBaseStorage()
  )

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ctxTransactionState.Provider value={{ contextBase, setContextBase }}>
      {children}
    </ctxTransactionState.Provider>
  )
}

export { ctxTransactionState, TransactionStateContext }
